import SSOButton from "./SSOButton";

export default SSOButton;
